export interface ColliderConfig {
  x: number;
  y: number;
  width: number;
  height: number;
  color: number;
  visible: boolean;
}

export interface PolygonColliderConfig {
  points: number[]; // Array of x,y coordinates [x1, y1, x2, y2, ...]
  color?: number;
  visible?: boolean;
}

export interface WallColliderConfig {
  wallColor: number;
  wallThickness: number;
}

export interface CollidersConfig {
  walls: WallColliderConfig;
  obstacles: ColliderConfig[];
  polygons: PolygonColliderConfig[];
}

export const collidersConfig: CollidersConfig = {
  walls: {
    wallColor: 0x8b4513, // Brown color for walls
    wallThickness: 20,
  },
  obstacles: [
    { x: 300, y: 200, width: 100, height: 80, color: 0x696969, visible: true },
    { x: 800, y: 400, width: 120, height: 60, color: 0x696969, visible: true },
    { x: 1200, y: 300, width: 80, height: 100, color: 0x696969, visible: true },
    { x: 600, y: 800, width: 150, height: 40, color: 0x696969, visible: true },
    { x: 1400, y: 600, width: 90, height: 90, color: 0x696969, visible: true },
    { x: 200, y: 1000, width: 200, height: 50, color: 0x696969, visible: true },
    { x: 1000, y: 1100, width: 60, height: 120, color: 0x696969, visible: true },
    { x: 1600, y: 200, width: 100, height: 200, color: 0x696969, visible: true },
  ],
  polygons: [
    //TOP, TAVERN AND LEFT OF GEREJA
    {
      "points": [
        1769.339502625588,
        795.4169270573466,
        2003.339502625588,
        890.4169270573466,
        2256.339502625588,
        826.4169270573466,
        2407.339502625588,
        991.4169270573466,
        2238.339502625588,
        1053.4169270573466,
        2181.8059127667675,
        1192.5754279040682,
        2081.4035869450668,
        1141.755225354471,
        1410.3617464407434,
        1296.8145094216475,
        1320.7976291137352,
        1249.2506040838448,
        1167.7968261461874,
        1294.2502525761106,
        1033.7968260447105,
        1225.250252531688,
        933.7968260447078,
        1255.2502525316872,
        933.7968260447078,
        1296.2502525316872,
        873.7968260447078,
        1294.2502525316872,
        856.7968260447078,
        1183.2502525316872,
        1128.3841385304486,
        602.5464020933676
      ]
    },
    {
      "points": [
        2251.445007561383,
        1050.5428288651415,
        2302.445007561383,
        1139.5428288651415,
        2189.445007561383,
        1185.5428288651415,
        2145.445007561383,
        1093.5428288651415
      ]
    },
    //TOP OF GEREJA, RIGHT OF GEREJA
    {
      "points": [
        2555.687337521499,
        924.0464360963543,
        2411.687337521499,
        787.0464360963543,
        2653.687337521499,
        707.0464360963543,
        2267.687337521499,
        574.0464360963543,
        2206.687337521499,
        576.0464360963543,
        2323.687337521499,
        680.0464360963543,
        2110.687337521499,
        749.0464360963543,
        2007.687337521499,
        692.0464360963543,
        1943.687337521499,
        716.0464360963543,
        1878.687337521499,
        693.0464360963543,
        1733.687337521499,
        788.0464360963543,
        1533.436649305782,
        722.1768316400298,
        1579.4158554714822,
        529.1749502535761,
        2301.4158513021976,
        407.17494987634706,
        2794.4158513014454,
        669.1749498762794
      ]
    },
    //AROUND POTTERY HOUSE
    {
      "points": [
        2538.7471862575812,
        1252.1471862576163,
        3071.592461364019,
        1453.4137133118252,
        3092.502004281079,
        1465.4310336822596,
        3646.502005385796,
        1225.4310390968838,
        3366.9245450602552,
        1100.083189333192,
        3403.924545060305,
        1066.083189333192,
        3322.924545060305,
        1045.083189333192,
        3264.924545060305,
        1073.083189333192,
        3058.924545060305,
        988.083189333192,
        3067.9260272888123,
        924.4728974805815,
        2991.9260243566832,
        904.4728937289983,
        2941.9260243566832,
        906.4728937289983,
        2739.9260243566832,
        971.4728937289983,
        2562.9260243566832,
        916.4728937289983,
        2803.9260243566832,
        659.4728937289983,
        3416.9260243566832,
        821.4728937289983,
        3548.9260243566832,
        917.4728937289983,
        3524.9260243566832,
        1010.4728937289983,
        3433.8886794012606,
        1084.4355487736213,
        3673.8886794012606,
        1224.4355487736213,
        3108.8886794012606,
        1474.4355487736213,
        2525.8886794012606,
        1272.4355487736213
      ]
    },
    {
      "points": [
        2575.277371799345,
        1259.5484554502166,
        2779.2775469807184,
        1195.5487881029428,
        2900.2775469807266,
        1279.548788102961,
        2814.2775469807266,
        1312.548788102961,
        3070.2775469807266,
        1391.548788102961,
        3075.0610179369037,
        1433.9348567928464,
        3582.0562625425214,
        1232.927503671042,
        3583.0562625313582,
        1246.9275036537813,
        3085.0562625309503,
        1461.9275036531444,
        2563.0562625309503,
        1274.9275036531444
      ]
    },
    // {
    //   "points": [
    //     2540.0562625309503,
    //     1250.9275036531444,
    //     2776.0562625309503,
    //     1193.9275036531444,
    //     2761.0562625309503,
    //     1234.9275036531444,
    //     2620.0562625309503,
    //     1276.9275036531444
    //   ]
    // },
    // {
    //   "points": [
    //     3108.898839242572,
    //     1474.3614036655672,
    //     3664.906882709197,
    //     1224.3648486085394,
    //     3682.906882709197,
    //     1234.3648486085394,
    //     3125.906882709197,
    //     1488.3648486085394
    //   ]
    // },
    {
      "points": [
        3115.7068827092216,
        1288.3648486085394,
        3246.7068827092216,
        1332.3648486085394,
        3390.7068827092216,
        1281.3648486085394,
        3270.7068827092216,
        1223.3648486085394
      ]
    },
    {
      "points": [
        3115.2734854473247,
        1297.389235226212,
        3269.2734854473247,
        1342.389235226212,
        3222.2734854473247,
        1362.389235226212,
        3102.2734854473247,
        1307.389235226212
      ]
    },
    {
      "points": [
        3114.2734854473247,
        1287.389235226212,
        3100.2734854473247,
        1303.389235226212,
        3183.2734854473247,
        1344.389235226212,
        3262.2734854473247,
        1337.389235226212
      ]
    },
    {
      "points": [
        2777.9079733328763,
        1194.4079077038803,
        2908.9079733328763,
        1282.4079077038803,
        2835.9079733328763,
        1320.4079077038803,
        2720.9079733328763,
        1252.4079077038803
      ]
    },
    {
      "points": [
        2781.9079733328763,
        1200.4079077038803,
        2916.9079733328763,
        1269.4079077038803,
        2904.9079733328763,
        1284.4079077038803,
        2782.9079733328763,
        1232.4079077038803
      ]
    },
    {
      "points": [
        3097.4823075294094,
        1305.705678258662,
        3083.4809755277647,
        1315.705678246231,
        3218.4809747431054,
        1385.7056782462248,
        3292.4809747431054,
        1372.7056782462248
      ]
    },
    {
      "points": [
        3569.1095874951325,
        1199.0980664016122,
        3631.1095874951325,
        1224.0980664016122,
        3434.1095874951325,
        1301.0980664016122,
        3386.1095874951325,
        1262.0980664016122
      ]
    },
    {
      "points": [
        3366.1763276498987,
        1100.159257017501,
        3353.1763276498987,
        1116.159257017501,
        3555.1763276498987,
        1214.159257017501,
        3570.1763276498987,
        1197.159257017501
      ]
    },
    //AROUND THE GRAVEYARD
    {
      "points": [
        3524.961095251555,
        1010.7180956268073,
        3436.961095251555,
        1077.7180956268073,
        3829.961095251555,
        942.7180956268073,
        3821.961095251555,
        847.7180956268073,
        3954.961095251555,
        800.7180956268073,
        4002.961095251555,
        807.7180956268073,
        4163.961095251555,
        764.7180956268073,
        4328.961095251555,
        840.7180956268073,
        4258.961095251555,
        980.7180956268073,
        4139.961095251555,
        1039.7180956268073,
        4064.961095251555,
        1138.7180956268073,
        4131.961095251555,
        1195.7180956268073,
        3389.126953987038,
        1547.5522368915026,
        3406.502108691122,
        1580.5995737863755,
        4370.231046490888,
        1162.9534054540109,
        4567.889189963133,
        816.1900597880093,
        4540.889548618787,
        746.1896438023616,
        4189.176970475553,
        617.100215561501,
        3713.1482258437927,
        661.9287814330017,
        3506.173261540106,
        761.6227746560583
      ]
    },
    {
      "points": [
        3992.1419325779134,
        809.945440837219,
        3954.1419325779134,
        800.945440837219,
        3819.1419325779134,
        841.945440837219,
        3936.1419325779134,
        900.945440837219,
        3963.1419325779134,
        897.945440837219
      ]
    },
    {
      "points": [
        3822.1419325779134,
        841.945440837219,
        3827.1419325779134,
        943.945440837219,
        3933.1419325779134,
        899.945440837219
      ]
    },
    //SOUTH OF GRAVEYARD
    {
      "points": [
        3378.8986580718515,
        1549.4097650851909,
        3262.8996174855374,
        1615.4094080263355,
        3445.8996174855374,
        1709.4094080263355,
        3601.8996174855374,
        1730.4094080263355,
        4105.2996174855,
        1583.1389319330337,
        4373.699617485463,
        1622.1389319330337,
        4682.844191721817,
        1512.7943576623172,
        4380.844191770945,
        1168.7943576475386,
        4365.844191770945,
        1157.7943576475386
      ]
    },
    //TOP LEFT, ENTRANCE, HOUSE
    {
      "points": [
        1529.0484186868503,
        1521.1518928655273,
        1449.6995778718178,
        1572.2305696863314,
        1594.6845175353174,
        1697.2339663628245,
        1817.684445243362,
        1666.2339826673997,
        1925.6844445928105,
        1791.233982814123,
        1724.6844445578165,
        1873.2339828220138,
        1663.6844445578165,
        1846.2339828220138,
        877.6844445578165,
        1840.2339828220138,
        872.6844445578165,
        1426.2339828220138,
        874.6844445578165,
        1280.2339828220138,
        939.6844445578165,
        1301.2339828220138,
        1137.6844445578165,
        1409.2339828220138,
        1397.6844445578165,
        1484.2339828220138
      ]
    },
    {
      "points": [
        1459.8876664797842,
        1852.6244289131507,
        1453.6625746220548,
        2022.7015766755476,
        1805.4252158728546,
        2060.270713479744,
        2223.4252185073005,
        1876.2707140124182,
        2340.4252185073174,
        1933.2707140124198,
        1754.4252185073174,
        2267.27071401242,
        1263.4252185073174,
        2362.27071401242
      ]
    },
    {
      "points": [
        1832.9888114863318,
        1713.1917738038487,
        1960.9895243255771,
        1775.1917606676807,
        1920.9895305091225,
        1793.1917605537308
      ]
    },
    {
      "points": [
        1854.9895310851136,
        1714.1917605431165,
        1954.9895310854395,
        1775.1917605431122,
        1928.9895310854506,
        1781.1917605431122
      ]
    },
    //MC HOUSE and toilet
    {
      "points": [
        1535.6324601658189,
        1520.4864894063462,
        1653.3812500265494,
        1582.2789033632262,
        2007.4195762114132,
        1499.3194624110877,
        1904.4214523926548,
        1426.3214478976436
      ]
    },
    {
      "points": [
        1529.2550723763566,
        1513.5542067742163,
        1858.8274502994905,
        1405.9738816210333,
        2007.825483956839,
        1485.9712131009496,
        1943.8253881741057,
        1519.9710831143734
      ]
    },
    {
      "points": [
        1524.6497124859634,
        1487.6603894905106,
        1834.6497115805234,
        1381.6603896918782,
        2010.6497115748343,
        1480.6603896931433,
        2013.649711574545,
        1513.6603896932068,
        1645.649711574545,
        1579.6603896932068
      ]
    },
    // {
    //   "points": [
    //     938.1205850499365,
    //     1299.558787847861,
    //     1387.1205850499364,
    //     1484.558787847861,
    //     1920.1205850499364,
    //     1377.558787847861,
    //     2009.1205850499364,
    //     1442.558787847861,
    //     2007.1205850499364,
    //     1490.558787847861,
    //     1645.1205850499364,
    //     1578.558787847861,
    //     1552.1205850499364,
    //     1521.558787847861,
    //     1480.1205850499364,
    //     1546.558787847861,
    //     1469.581674142968,
    //     1680.0374167428047,
    //     2450.5816741429767,
    //     1824.037416742875,
    //     2464.5816741429767,
    //     1920.037416742875,
    //     768.9876219528317,
    //     1807.4374158543696,
    //     776.9816742177003,
    //     1301.4374167428673
    //   ]
    // },
    //TOP LEFT OF LAKE
    {
      "points": [
        2321.3998713610417,
        1924.7287342176073,
        2442.4028344590333,
        1885.781312790023,
        2793.4028350235403,
        2269.781322806911,
        2523.4028350235403,
        2449.7813228069267,
        2552.0200074274217,
        2661.3991838859474,
        1494.0201994949512,
        2658.399991505228,
        1494.0202014834763,
        2278.3999998667205
      ]
    },
    {
      "points": [
        2527.63499056652,
        1870.179959652663,
        2959.8056352858803,
        2205.065505751422,
        3545.0720902539083,
        2000.1786291423168,
        3196.022407694727,
        1811.0808380481144,
        2856.022407694727,
        1635.0808380481144,
        2678.644810577086,
        1573.2157499825307,
        2557.146477803103,
        1613.8043342033393,
        2427.1434676401714,
        1566.8018490596908,
        2171.143187081173,
        1643.8016174345494,
        2525.1431870811493,
        1816.8016174345307
      ]
    },
    {
      "points": [
        3541.3614109657597,
        2001.595340135674,
        3623.364843200051,
        2070.5688226693587,
        3568.3650468694277,
        2166.567249118313,
        3216.365059265157,
        2107.567153348827
      ]
    },
    // {
    //   "points": [
    //     2340.4026688919475,
    //     1607.9068827094075,
    //     2824.4026688919475,
    //     1624.9068827094075,
    //     3359.400951578785,
    //     1891.9068827094075,
    //     3619.006954458914,
    //     2049.9111682795897,
    //     2793.822084132871,
    //     2172.399999999998,
    //     2669.742488402807,
    //     2173.399999999998,
    //     2532.742488402807,
    //     2645.399999999998,
    //     2232.6678497156804,
    //     1921.2751368942213,
    //     2448.2290039755517,
    //     1909.506117680468,
    //     2426.2290039755517,
    //     1778.506117680468,
    //     2242.2290039755517,
    //     1681.506117680468,
    //     2354.2290039755517,
    //     1595.506117680468
    //   ]
    // },
    //PORT
    {
      "points": [
        4497.9913036902935,
        1977.1194436649948,
        4312.9913036902935,
        1877.1194436649948,
        4293.9913036902935,
        1877.1194436649948,
        4470.9913036902935,
        2003.1194436649948,
        4251.9913036902935,
        2055.119443664995,
        4063.9913036902935,
        2004.1194436649948,
        3641.9913036902935,
        2079.119443664995,
        3618.9913036902935,
        2067.119443664995,
        3585.9913036902935,
        2127.119443664995,
        4498.9913036902935,
        2116.119443664995
      ]
    },
    // {
    //   "points": [
    //     4478.425142392985,
    //     1817.2440902428987,
    //     4626.425157804977,
    //     1923.244090248173,
    //     4476.425157804977,
    //     1963.244090248173,
    //     4496.425157804977,
    //     1992.244090248173,
    //     4651.425157804977,
    //     1942.244090248173,
    //     4673.425157804977,
    //     1940.244090248173,
    //     4494.425157804977,
    //     1812.244090248173
    //   ]
    // },
    // {
    //   "points": [
    //     4317.76172290027,
    //     1875.8442400223666,
    //     4325.761701901713,
    //     1870.8440907033757,
    //     4488.761701837733,
    //     1955.8440902484156,
    //     4468.761701837703,
    //     1967.8440902481757
    //   ]
    // },
    {
      "points": [
        4478.586354587551,
        1821.3622069010503,
        4455.586354579334,
        1824.3622069010503,
        4605.586354579252,
        1926.3622069010503,
        4615.586354579252,
        1924.3622069010503
      ]
    },
    {
      "points": [
        4477.958966255105,
        1966.9014850104784,
        4613.958967316417,
        1926.9014854547124,
        4635.9589673166365,
        1959.901485454804,
        4494.9589673166365,
        1987.901485454804
      ]
    },
    //LAKE RIGHT OF DOCK
    {
      "points": [
        4640.409208283492,
        1961.514888970369,
        4799.4085058697,
        1934.5149129523147,
        5366.408505580801,
        1629.5149129621768,
        5404.408505580801,
        1559.5149129621768,
        5521.765214290226,
        1547.5149129621768,
        5536.808505576189,
        1666.5149129621768,
        5785.999999859139,
        1902.6642551733762,
        5828.999999998106,
        2132.602884000009,
        5738.999999999991,
        2238.385931816335,
        5633.999999999991,
        2398.3999730525375,
        5279.999999999991,
        2445.3999998885847
      ]
    },
    {
      "points": [
        5526.999999999991,
        1567.3620633260466,
        5566.999999999991,
        1577.3620633260466,
        5558.999999999991,
        1675.3620633260466,
        5535.999999999991,
        1689.3620633260466
      ]
    },
    //SOUTH OF LAKE
    {
      "points": [
        5274.972998258039,
        2445.399999999998,
        4967.973028589743,
        2494.399999999998,
        4584.973028594677,
        2516.399999999998,
        3563.822365339919,
        2508.399999999998,
        3186.1864053411527,
        2396.399999999998,
        3107.186405340646,
        2299.399999999998,
        3142.186405340646,
        2153.399999999998,
        3217.186405340646,
        2108.399999999998
      ]
    },
    //PATH TOP RIGHT OF LAKE
    {
      "points": [
        4696.999999999991,
        1507.6801799541474,
        5022.999999999991,
        1387.68017997892,
        5411.999999999991,
        1335.68017997892,
        5601.999999999991,
        1368.68017997892,
        5854.999999999991,
        1503.68017997892,
        5975.999999999991,
        1547.68017997892,
        5994.999999999991,
        1568.68017997892,
        5993.999999999991,
        1258.68017997892,
        5051.999999999991,
        1230.68017997892
      ]
    },
    //Tiang deket rumah sondakh
    {
      "points": [
        2127.8080302546705,
        1635.8984848098316,
        2147.808030252803,
        1618.8984848098344,
        2225.8080302527883,
        1655.8984848098344,
        2194.8080302527883,
        1673.8984848098344
      ]
    }
    //House near grave
    //Under tugu
    //Signage tengah  kota
    //BH
  ]
};
